import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {

        //配置目录
        addcatalog(context, payload) {
            return D.add({
                ...payload
            })
        },
        delcatalog(context, payload) {
            return D.del({
                ...payload
            })
        },
        updatecatalog(context, payload) {
            return D.edit({
                ...payload
            })
        },
        querycatalogs(context, payload) {
            return D.select({
                ...payload
            })
        },

        //配置规则
        addrule(context, payload) {
            return D.add({
                ...payload
            })
        },
        delrule(context, payload) {
            return D.del({
                ...payload
            })
        },
        updaterule(context, payload) {
            return D.edit({
                ...payload
            })
        },
        queryrulespage(context, payload) {
            return D.select({
                ...payload
            })
        },


        //配置元数
        addconfiginfo(context, payload) {
            return D.add({
                ...payload
            })
        },
        delconfiginfo(context, payload) {
            return D.del({
                ...payload
            })
        },
        updateconfiginfo(context, payload) {
            return D.edit({
                ...payload
            })
        },
        queryconfiginfopage(context, payload) {
            return D.select({
                ...payload
            })
        },

        queryplatform(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryconfiginfo(context, payload) {
            return D.select({
                ...payload
            })
        },

        //配置明细
        queryconfigdetailpage(context, payload) {
            return D.select({
                ...payload
            })
        },

        saveconfig(context, payload) {
            return D.edit({
                ...payload
            })
        },

        queryconfig(context, payload) {
            return D.select({
                ...payload
            })
        },

        delconfig(context, payload) {
            return D.del({
                ...payload
            })
        },

        configcover(context, payload) {
            return D.edit({
                ...payload
            })
        },
        //简单配置
        simpquerypage(context, payload) {
            return D.select({
                ...payload
            })
        },
        simpadd(context, payload) {
            return D.add({
                ...payload
            })
        },
        simpdel(context, payload) {
            return D.del({
                ...payload
            })
        },
        simpedit(context, payload) {
            return D.edit({
                ...payload
            })
        },
        simpdetail(context, payload) {
            return D.select({
                ...payload
            })
        },
        simpquerybycatalog(context, payload) {
            return D.select({
                ...payload
            })
        },

    }
}
